import { render } from "./UpgradeChampion.vue?vue&type=template&id=e47d2d68"
import script from "./UpgradeChampion.vue?vue&type=script&lang=js"
export * from "./UpgradeChampion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/house/windowOverlay/UpgradeChampion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e47d2d68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e47d2d68', __exports__)) {
    api.reload('e47d2d68', __exports__)
  }
  
  module.hot.accept("./UpgradeChampion.vue?vue&type=template&id=e47d2d68", () => {
    api.rerender('e47d2d68', render)
  })

}


export default __exports__